import gql from "graphql-tag"

const SOCIALS_FOLLOWER_SYNC_RUN = gql`
  mutation socialsFollowerSyncRun(
    $socialsFollowerSyncRunInput: SocialsJobRunInput!
  ) {
    socialsFollowerSyncRun(
      socialsFollowerSyncRunInput: $socialsFollowerSyncRunInput
    ) {
      status
      message
      jobId
      runId
    }
  }
`

export default SOCIALS_FOLLOWER_SYNC_RUN
